export async function stableGetRequest(url, options) {
  var sleepTime = 1000
  while(true) {
    try {
      let data = await fetch(url, options)
      if(data.status === 200) {
        return data.json()
      }
    }
    catch(e) {
      console.log(e)
    }
    sleepTime *= 2
    await new Promise(resolve => setTimeout(resolve, sleepTime));
  }
}



// WEBPACK FOOTER //
// ./src/util/requests/stableGetRequest.js